import { EEventType } from '../../types/events';
import { EMergeStatus } from '../../types/social';
import { SOCIAL_MERGE_TYPE } from '../../constants/action_types';
import { authenticate } from './authenticate';
import { trackSocialMergeSucceed } from '../../utils/tracking';
import { fetchMergeUser } from '../../repositories/social-users/v1/merge-user';
export function merge(parameters) {
  var socialType = parameters.socialType,
      socialLoginId = parameters.socialLoginId,
      email = parameters.email,
      password = parameters.password;
  return function (dispatch, _getState, context) {
    var httpApi = context.httpApi;
    dispatch({
      type: SOCIAL_MERGE_TYPE,
      status: EMergeStatus.Loading
    });
    return fetchMergeUser({
      httpApi: httpApi,
      parameters: {
        socialLoginId: socialLoginId,
        email: email,
        password: password
      },
      config: {
        requestConfig: {
          headers: [['Content-Type', 'application/json']],
          withCredentials: true
        }
      }
    }).then(function (response) {
      if (response.statusCode === 200) {
        var _socialLoginId = response.response.socialLoginId;

        var _email = response.response.email || '';

        var token = response.response.token || '';
        dispatch({
          type: SOCIAL_MERGE_TYPE,
          status: EMergeStatus.Succeed
        });
        context.emitter.emit(EEventType.SocialMergeSucceed);
        trackSocialMergeSucceed();
        dispatch(authenticate({
          socialType: socialType,
          socialLoginId: _socialLoginId,
          email: _email,
          token: token
        }));
        return;
      }

      dispatch({
        type: SOCIAL_MERGE_TYPE,
        status: EMergeStatus.Failed,
        error: response.response.message
      });
    }).catch(function (error) {
      context.logger.error(error, {
        domain: 'auth-widget.api.socialMerge',
        socialType: socialType
      });
      dispatch({
        status: EMergeStatus.Failed,
        type: SOCIAL_MERGE_TYPE,
        error: 'Произошла непредвиденная ошибка'
      });
    });
  };
}